import React from 'react';
import Link from 'src/components/atoms/Link';
import classnames from 'classnames';

import styles from './aicrowdLogo.module.scss';
const { logomark, brand, logoText, aiText, text } = styles;

export type AicrowdLogoProps =
  | {
      type: 'mark' | 'text';
      size: number;
      fontFamily?: string;
      fontWeight?: number;
    }
  | {
      type: 'full';
      size?: never;
      fontFamily?: never;
      fontWeight?: never;
    };

const AicrowdLogo = ({ type, size, fontFamily, fontWeight }: AicrowdLogoProps) => {
  const isFull = type === 'full';
  const isMark = type === 'mark';
  const isText = type === 'text';
  return (
    <>
      {/* One anchor, not two: an <a> nested in an <a> is invalid HTML, and the
          browser closes the outer one early — which left the styled element
          outside the link it was supposed to be. */}
      <a
        href="/"
        className={classnames({ [brand]: isFull, [logomark]: isMark, [text]: isText })}
        style={{ width: isMark && `${size}px`, height: isMark && `${size}px` }}>
        {type === 'text' && (
          <span className={logoText}>
            <span className={aiText} style={{ fontSize: `${size}px`, fontFamily, fontWeight }}>
              AI
            </span>
            <span style={{ fontSize: `${size}px`, fontFamily, fontWeight, color: '#1f1f1f' }}>crowd</span>
          </span>
        )}
      </a>
    </>
  );
};

export default AicrowdLogo;
